"use strict";
export var ChainId = /* @__PURE__ */ ((ChainId2) => {
  ChainId2[ChainId2["_1"] = 1] = "_1";
  ChainId2[ChainId2["_10"] = 10] = "_10";
  ChainId2[ChainId2["_56"] = 56] = "_56";
  ChainId2[ChainId2["_130"] = 130] = "_130";
  ChainId2[ChainId2["_137"] = 137] = "_137";
  ChainId2[ChainId2["_324"] = 324] = "_324";
  ChainId2[ChainId2["_480"] = 480] = "_480";
  ChainId2[ChainId2["_1868"] = 1868] = "_1868";
  ChainId2[ChainId2["_8453"] = 8453] = "_8453";
  ChainId2[ChainId2["_10143"] = 10143] = "_10143";
  ChainId2[ChainId2["_42161"] = 42161] = "_42161";
  ChainId2[ChainId2["_42220"] = 42220] = "_42220";
  ChainId2[ChainId2["_43114"] = 43114] = "_43114";
  ChainId2[ChainId2["_81457"] = 81457] = "_81457";
  ChainId2[ChainId2["_7777777"] = 7777777] = "_7777777";
  ChainId2[ChainId2["_1301"] = 1301] = "_1301";
  ChainId2[ChainId2["_84532"] = 84532] = "_84532";
  ChainId2[ChainId2["_11155111"] = 11155111] = "_11155111";
  return ChainId2;
})(ChainId || {});
